<template>
  <div class="share-handlian-wrap">
    <el-dialog
      title="分享给传联好友"
      :visible.sync="shareHandlian"
      width="500px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="clearShareFeedForm"
      custom-class="handlian-share-feed"
    >
      <div class="share-btn-bar">
        <el-button class="handlian-btn" type="primary" @click="shareThisFeed"
          >分享</el-button
        >
      </div>
      <div>
        <el-form
          :model="shareFeedForm"
          ref="shareFeedForm"
          class="demo-ruleForm"
        >
          <el-collapse>
            <el-collapse-item v-for="(item, index) in contactBook" :key="index">
              <template slot="title">
                {{ item.name }}
                <span class="member-num">({{ item.member.length }})</span>
              </template>
              <div>
                <div v-for="friend in item.member" :key="friend.userId">
                  <el-form-item prop="userID" class="share-form-item">
                    <el-checkbox-group v-model="shareFeedForm.userID">
                      <el-checkbox
                        :label="friend.userId"
                        name="userID"
                        class="share-check-box"
                      >
                        <img
                          class="share-user-avatar"
                          src="../assets/image/cl_user_avatar.png"
                          v-real-img="friend.avatar"
                        />
                        <span>{{ initFriendName(friend) }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { random } from "../utils/feed";
export default {
  name: "share-hand-lian",
  data() {
    return {
      shareHandlian: false,
      shareForbit: false,
      shareFeedForm: {
        userID: [],
      },
      awaitFeed: {},
    };
  },
  computed: {
    ...mapGetters(["contactBook", "contactsList"]),
  },
  mounted() {
    this.$bus.$on("open-share-contacts", this.openContact);
  },
  methods: {
    initFriendName(friend) {
      if (friend.remark) {
        return `${friend.name}(${friend.remark})`;
      } else {
        return `${friend.name}`;
      }
    },
    openContact(data) {
      if (data) {
        this.shareHandlian = true;
        this.awaitFeed = JSON.parse(data);
      }
    },
    shareThisFeed() {
      // console.log(this.$refs.shareFeedForm)
      let _this = this;
      _this.$refs["shareFeedForm"].validate((valid) => {
        let userArray = _this.$refs["shareFeedForm"].model.userID;
        if (userArray.length != 0) {
          // console.log(userArray)
          for (let index = 0; index < userArray.length; index++) {
            const element = userArray[index];
            _this.sendCustomMsg(element, index);
          }
        } else {
          _this.$message({
            message: "请选择好友",
            type: "warning",
          });
        }
      });
    },
    clearShareFeedForm() {
      this.$refs["shareFeedForm"].resetFields();
      this.shareHandlian = false;
    },
    sendCustomMsg(userID, index) {
      let _this = this;
      var data = {
        id: _this.awaitFeed.modelId,
        title: _this.awaitFeed.title,
        content: _this.awaitFeed.content.slice(0, 150),
        url: _this.awaitFeed.uriKey[0],
      };
      var desc = "";
      switch (_this.awaitFeed.modelType) {
        case "1":
          desc = "304";
          break;
        case "2":
          desc = "320";
          break;
        case "3":
          desc = "336";
          break;
        case "4":
          desc = "352";
          break;
      }

      let message = tim.createCustomMessage({
        to: String(userID),
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          data: desc,
          description: String(random(1, 6)),
          extension: JSON.stringify(data),
        },
      });
      let promise = tim.sendMessage(message);
      promise
        .then(function (imResponse) {
          // 发送成功
          if (index == 0) {
            _this.$message({
              message: "分享成功！",
              type: "success",
            });
          }
          _this.clearShareFeedForm();
        })
        .catch(function (imError) {
          // 发送失败
          if (index == 0) {
            _this.$message({
              message: "分享失败，稍后再试",
            });
          }
          console.warn("sendMessage error:", imError);
        });
    },
  },
};
</script>
<style scoped>
.share-btn-bar {
  margin-bottom: 10px;
}
</style>